import { store } from '../../store'
import { httpgst } from '../../main'

// actions
const actions = {
  getTotalItems ({commit, dispatch}, payload) {
    let url = 'api/total-items/expenses_loaded/' + store.state.userLogged.company[0].id + '/' + payload.event.filter
    let params = {
      anio: payload.event.date,
      userId: store.state.userLogged.roles[0].id === 3 ? store.state.userLogged.id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {params: params})
      .then(
        response => {
          commit('totalItems', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getExpensesApproved ({commit, dispatch}, payload) {
    let url = 'api/total-items/expenses_payable/' + store.state.userLogged.company[0].id + '/' + payload.event.filter
    let params = {
      anio: payload.event.date,
      userId: store.state.userLogged.roles[0].id === 3 ? store.state.userLogged.id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {params: params})
      .then(
        response => {
          commit('expensesPayable', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getAmountCategory ({commit, dispatch}, payload) {
    let url = 'api/total-items/amount_by_category/' + store.state.userLogged.company[0].id + '/' + payload.event.filter
    let params = {
      anio: payload.event.date,
      userId: store.state.userLogged.roles[0].id === 3 ? store.state.userLogged.id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {params: params})
      .then(
        response => {
          commit('amountCategory', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getRejected ({commit, dispatch}, payload) {
    let url = 'api/total-items/rejected_expenses/' + store.state.userLogged.company[0].id + '/' + payload.event.filter
    let params = {
      anio: payload.event.date,
      userId: store.state.userLogged.roles[0].id === 3 ? store.state.userLogged.id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {params: params})
      .then(
        response => {
          commit('expensesRejected', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  expensesByAmount ({commit, dispatch}, payload) {
    let url = 'api/total-items/by_amount/' + store.state.userLogged.company[0].id + '/' + payload.event.filter
    let params = {
      anio: payload.event.date,
      userId: store.state.userLogged.roles[0].id === 3 ? store.state.userLogged.id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {params: params})
      .then(
        response => {
          commit('byAmount', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  projectExpenses ({commit, dispatch}, payload) {
    let url = 'api/total-items/project_expenses/' + store.state.userLogged.company[0].id + '/' + payload.event.filter
    let params = {
      anio: payload.event.date,
      userId: store.state.userLogged.roles[0].id === 3 ? store.state.userLogged.id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {params: params})
      .then(
        response => {
          commit('projectExpenses', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

// mutations
const mutations = {
  totalItems (state, payload) {
    payload.event.context.loadingTotalExpenses = false
    let total = payload.response.data
    let expenses = payload.event.context.totalExpenses
    expenses.size = 0
    expenses.size = (total.fiscales.size ? total.fiscales.size : 0) + (total.no_fiscales.size ? total.no_fiscales.size : 0)
    expenses.total = 0
    expenses.total = (total.fiscales.total ? total.fiscales.total : 0) + (total.no_fiscales.total ? total.no_fiscales.total : 0)
  },
  expensesPayable (state, payload) {
    payload.event.context.payables = payload.response.data
    // if (store.state.userLogged.roles[0].id === 2) {
    //   payload.event.context.payables = payload.response.data
    // }
    // if (store.state.userLogged.roles[0].id === 3) {
    //   let total = payload.response.data
    //   payload.event.context.payables = total
    // }
    let items = payload.response.data
    let temp = []
    if (items.size === 0) {
      for (let i = 1; i < 13; i++) {
        temp.push(0)
      }
    } else {
      for (let i = 1; i < 13; i++) {
        const item = items[i]
        temp.push(item)
      }
    }
    payload.event.context.series2[0].data = temp
    payload.event.context.loadingPayables = false
  },
  amountCategory (state, payload) {
    let categories = payload.event.context.categories
    let donut = []
    let amounts = payload.response.data
    payload.event.context.amounts = amounts
    for (let i = 0; i < categories.length; i++) {
      const item = categories[i]
      item.total = 0
      let result = amounts.find(thing => thing.gst_categories_id === item.id)
      if (result) {
        item.total = result.total
      }
    }
    payload.event.context.categoriesAmount = categories
    for (let i = 0; i < categories.length; i++) {
      const item = categories[i]
      item.size = 0
      let result = amounts.find(thing => thing.gst_categories_id === item.id)
      if (result) {
        item.size = result.size
      }
      donut.push(item.size)
    }
    payload.event.context.series3 = donut
    payload.event.context.loadingCategoriesAmount = false
  },
  expensesRejected (state, payload) {
    payload.event.context.rejecteds = payload.response.data
    payload.event.context.loadingRejecteds = false
  },
  byAmount (state, payload) {
    payload.event.context.loadingByAmount = false
    payload.event.context.byAmount = payload.response.data
  },
  projectExpenses (state, payload) {
    let result = payload.response.data
    let projects = []
    for (let i = 0; i < result.length; i++) {
      const project = result[i]
      let temp = {}
      temp.name = project.project
      temp.data = []
      for (let j = 1; j < 13; j++) {
        const item = project[j]
        temp.data.push(item)
      }
      projects.push(temp)
    }
    payload.event.context.series = projects
    payload.event.context.loadingProjects = false
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingTotalExpenses = true
    payload.event.context.loadingByAmount = true
    payload.event.context.loadingPayables = true
    payload.event.context.loadingCategoriesAmount = true
    payload.event.context.loadingRejecteds = true
    payload.event.context.loadingProjects = true
    payload.event.context.loading = false
    // payload.event.context.refresh()
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js